import { useState } from "react"

export const BACK_IMG_URL =
  "https://assets.nflxext.com/ffe/siteui/vlv3/20bf1f4d-1c73-48fd-8689-310d6dd80efc/c189e65a-ee63-4eb2-bf50-a326fa27e2d8/BD-en-20240812-POP_SIGNUP_TWO_WEEKS-perspective_WEB_722e6c5b-1615-42d5-9aa1-7d15a7dda307_large.jpg"
export const LOGO_URL ="https://upload.wikimedia.org/wikipedia/commons/6/69/Netflix_logo.svg"
export const PROFILE_URL =
  "https://toppng.com/uploads/preview/icons-logos-emojis-user-icon-png-transparent-11563566676e32kbvynug.png"
export const options = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI1YjI4MDdmMmU0YTMwMTVlYjk5MTdjNjU1YjY4Y2E3ZiIsIm5iZiI6MTcyNDMzOTUyOS44NDMwMDgsInN1YiI6IjY2Yzc0ZGExNGRhNTZiMzA5MWNhOGFjNSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.VOAhY-6kFw4mkHf1sSKJrYYR4kwYKxT8oOr8tSidyL8",
  },
}
//api_key=5b2807f2e4a3015eb9917c655b68ca7f
export const MOVIE_CARD_IMG = "https://image.tmdb.org/t/p/w500/"

export const SUPPORTED_LANG = [
  { identifier: "en", value: "English" },
  { identifier: "bangla", value: "বাংলা" },
  { identifier: "chinese", value: "中国人" },
]

//export const API_KEY="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"
export const API_KEY="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"
export const SEARCH_MOVIE="https://api.themoviedb.org/3/search/movie?query="
export const XLOGO="https://img.freepik.com/free-vector/new-2023-twitter-logo-x-icon-design_1017-45418.jpg?size=338&ext=jpg&ga=GA1.1.2008272138.1724716800&semt=ais_hybrid.jpg"
export const FBLOGO="https://upload.wikimedia.org/wikipedia/commons/6/6c/Facebook_Logo_2023.png"

{/* <button
className="bg-transparent text-white rounded p-2 my-4 w-full flex items-center bg-blue-800/70  "
onClick={handleFacebookClick}
>
<svg
  viewBox="0 0 36 36"
  className="x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq x19dipnz"
  height="40"
  width="40"
>
  <path
    d="M20.181 35.87C29.094 34.791 36 27.202 36 18c0-9.941-8.059-18-18-18S0 8.059 0 18c0 8.442 5.811 15.526 13.652 17.471L14 34h5.5l.681 1.87Z"
    fill="#1877f2"
  ></path>
  <path
    className="xe3v8dz"
    d="M13.651 35.471v-11.97H9.936V18h3.715v-2.37c0-6.127 2.772-8.964 8.784-8.964 1.138 0 3.103.223 3.91.446v4.983c-.425-.043-1.167-.065-2.081-.065-2.952 0-4.09 1.116-4.09 4.025V18h5.883l-1.008 5.5h-4.867v12.37a18.183 18.183 0 0 1-6.53-.399Z"
    fill="#fff" // This can be any other color or #1877f2 as well
  ></path>
</svg>
<p className="text-white p-2 "> Sign in with Facebook</p>
</button> */}
export const FBID="https://www.facebook.com/share/ohd8re9qJK2Cnch3/?mibextid=qi2Omg"
export const XID="https://x.com/SheikhRahat48?t=eaf-bBd75DzZT6GbN2YVUA&s=35"